import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useAppData } from "../context";
import { useAuth0 } from "@auth0/auth0-react";
import InfoCard from "../components/InfoCard";
import HealthCard from "../components/HealthCard";
import { useTranslation } from "react-i18next";
import { formatDistanceToNow } from "date-fns";

const formatRelativeTime = (timestamp) =>
	timestamp ? formatDistanceToNow(new Date(timestamp), { addSuffix: true }) : "--";

export const Profile = () => {
	const { t } = useTranslation();
	const { user } = useAuth0();
	const data = useAppData();
	const rolePath = process.env.REACT_APP_AUTH0_ROLE_PATH || "roles";
	const roles = user[rolePath] || [];
	const isAdmin = Array.isArray(roles) && roles.includes("admin");

	return (
		<Container className="mb-5">
			<Row className="align-items-center profile-header mb-5 text-center text-md-left">
				<Col md={1}>
					<img
						src={user.picture}
						alt="Profile"
						className="rounded-circle img-fluid profile-picture mb-1 mb-md-0"
					/>
				</Col>
				<Col md>
					<h3>{user.name}</h3>
					<p className="lead text-muted">{user.email}</p>
				</Col>
			</Row>

			{/* Dummy API data */}
			<Row className="mb-4">
				<Col md={10}>
					<InfoCard label={t("Profile-User ID")} value={data.user.id} />
					<InfoCard label={t("Profile-User CustomerID")} value={data.customer.id} />
					<InfoCard label={t("Profile-User IDP ID")} value={data.user.idp_id} />
					<InfoCard label={t("Profile-Customer Name")} value={data.customer.display_name} />
					<InfoCard label={t("Profile-Customer Reference")} value={data.customer.customer_reference} />
					<InfoCard label={t("Profile-Customer ID")} value={data.customer.id} />
					{isAdmin &&
						Array.isArray(data.sites) &&
						data.sites.slice().sort((a, b) => a.id.localeCompare(b.id)).map((site, index) => {

							const healthData = site.health ? site.health : [];

							return (
								<HealthCard
									key={index}
									label={
										<>
											{t("Profile-Latest Health Check For Site With Id")}{" "}
											<span className="text-muted">{site.id} </span>
										</>
									}
									defaultValue={t("N/A")}
									subLabel={
										Array.isArray(healthData) && healthData[0]?.time
											? formatRelativeTime(healthData[0].time)
											: ""
									}
									value={
										Array.isArray(healthData) && healthData[0]?.system_data ? (
											<div>
												<ul style={{ paddingLeft: "1rem" }}>
													<li><strong>Status:</strong> {healthData[0].system_data.status ?? '-'}</li>
													<li><strong>Edge version:</strong> {healthData[0].system_data.version}</li>
													<li><strong>Local IP:</strong> {healthData[0].system_data.local_ip}</li>
													<li><strong>Inverter Type:</strong> {healthData[0].system_data.inverter_type}</li>
													<li><strong>Serial Number:</strong> {healthData[0].system_data.serial_number}</li>
													<li><strong>Steering Type:</strong> {healthData[0].system_data.steering_type}</li>
												</ul>

												{healthData[0].system_data.cpu_load?.cpu_load_percent !== undefined && (
													<p><strong>CPU Load:</strong> {healthData[0].system_data.cpu_load.cpu_load_percent}%</p>
												)}

												{healthData[0].system_data.memory && (
													<div>
														<strong>Memory:</strong>
														<ul style={{ paddingLeft: "1rem" }}>
															<li><strong>Used:</strong> {healthData[0].system_data.memory.memory_used}</li>
															<li><strong>Total:</strong> {healthData[0].system_data.memory.memory_total}</li>
															<li><strong>Available:</strong> {healthData[0].system_data.memory.memory_available}</li>
															<li><strong>Usage:</strong> {healthData[0].system_data.memory.memory_percent}%</li>
														</ul>
													</div>
												)}

												{Array.isArray(healthData[0].system_data.disks) && (
													<div>
														<strong>Disks:</strong>
														<ul style={{ paddingLeft: "1rem" }}>
															{healthData[0].system_data.disks.map((disk, index) => (
																<li key={index}>
																	<strong>{disk.mountpoint}</strong> ({disk.device}): {disk.used} used / {disk.total} total ({disk.percent} used)
																</li>
															))}
														</ul>
													</div>
												)}
											</div>
										) : t("N/A")
									}
								/>
							);
						})}
				</Col>
			</Row>

		</Container>
	);
};

export default Profile;
